module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticStyle: {
      "width": "850px",
      "margin": "auto"
    },
    attrs: {
      "title": _vm.title,
      "visible": _vm.dialogFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      },
      "close": _vm.close
    }
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "element-loading-text": _vm.elementLoadingText
    }
  }, [_c('div', {
    staticClass: "selectAddress"
  }, [(_vm.addList.length > 0) ? _c('table', [_c('tr', {
    staticClass: "addressHead"
  }, [_c('th', {
    staticClass: "select"
  }), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v("收货人")]), _vm._v(" "), _c('th', {
    staticClass: "location"
  }, [_vm._v("所在地区")]), _vm._v(" "), _c('th', {
    staticClass: "address"
  }, [_vm._v("详细地址")]), _vm._v(" "), _c('th', {
    staticClass: "mobile"
  }, [_vm._v("手机")])]), _vm._v(" "), _vm._l((_vm.addList), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_c('el-checkbox', {
      key: 'select_' + item.id,
      on: {
        "change": function($event) {
          return _vm.selectAddress(item.id)
        }
      },
      model: {
        value: (item.checked),
        callback: function($$v) {
          _vm.$set(item, "checked", $$v)
        },
        expression: "item.checked"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.province) + _vm._s(item.city) + _vm._s(item.area))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mobile))])])
  })], 2) : _c('img', {
    attrs: {
      "src": "http://img.static.knnnj.com/Default/dcb7cc98-a007-4f37-88cc-539fdaf24747.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存地址")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fe031c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/components/SelectAddress.vue
// module id = 760
// module chunks = 2